export default __webpack_public_path__ + "static/media/octahedron.5949b511.glb";